import { Model } from "vue-mc";

export class Usuario extends Model {
  defaults() {
    return {
      username: ""
      , nombre: ""
      , telefono: ""
      , interno: ""
      , celular: ""
      , correoElectronico: ""
      , foto: "/static/img/user_thumbnail.jpg"
      , fotoMiniatura: "/static/img/user_thumbnail.jpg"
      , enabled: true
      , activo: true
      , tipoUsuario: "ADMINISTRADOR"
      , idVendor: null
      , idRep: null
      , tts: false
    };
  }

  mutations() {
    return {
      username: (username) => username
      , nombre: (nombre) => nombre
      , telefono: (telefono) => telefono
      , interno: (interno) => interno
      , celular: (celular) => celular
      , correoElectronico: (correoElectronico) => correoElectronico
      , enabled: (enabled) => enabled
      , activo: (activo) => activo
      , foto: (foto) => foto
      , fotoMiniatura: (fotoMiniatura) => fotoMiniatura
      , tipoUsuario: (tipoUsuario) => tipoUsuario
      , idVendor: (idVendor) => idVendor
      , idRep: (idRep) => idRep
      , tts: (tts) => tts
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/seguridad/usuario.js